import WsSignaturePadComponent from './ws-signature-pad.component';
import WsSignaturePadController from './ws-signature-pad.controller';

const injectorName = 'ws.common.signature';

angular.module(injectorName, [])
  .component('wsSignaturePad', WsSignaturePadComponent)
  .controller('wsSignaturePadController', WsSignaturePadController);

export default injectorName;



// WEBPACK FOOTER //
// ./src/signature-pad/index.js